import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export function cawListApi(_x) {
  return _cawListApi.apply(this, arguments);
}
function _cawListApi() {
  _cawListApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", usePost("/web/cawList", params));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _cawListApi.apply(this, arguments);
}
export function cawDetailApi(_x2) {
  return _cawDetailApi.apply(this, arguments);
}
function _cawDetailApi() {
  _cawDetailApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", useGet("/web/findCawById/".concat(id)));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _cawDetailApi.apply(this, arguments);
}
export function downloadOss(_x3) {
  return _downloadOss.apply(this, arguments);
}
function _downloadOss() {
  _downloadOss = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(path) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", useGet(path, {
            responseType: 'blob'
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _downloadOss.apply(this, arguments);
}